import React from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
} from "@fluentui/react";

export interface ImageCropperProps {
  data?: any;
  onClose: Function;
  crop?: any;
}

export interface ImageCropperState {
  src: any;
  crop: any;
  croppedImageUrl: any;
  base64String: any;
  isOpen: boolean;
}

var imageRef: any;

class ImageCropper extends React.Component<
  ImageCropperProps,
  ImageCropperState
> {
  constructor(props: ImageCropperProps) {
    super(props);
    this.state = {
      src: null,
      crop: {
        unit: "%",
        width: 100,
        aspect: 16 / 9,
        ...this.props.crop,
      },
      croppedImageUrl: "",
      base64String: "",
      isOpen: true,
    };
  }
  componentDidMount = async () => {
    await this.onFileSelect(this.props.data);
  };
  onFileSelect = (file: File) => {
    if (file) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(file);
    }
  };
  onClose = (data?: any) => {
    this.props.onClose(data);
  };
  onImageLoaded = (image: any) => {
    imageRef = image;
  };

  onCropComplete = (crop: any) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop: any, percentCrop: any) => {
    this.setState({ crop });
  };
  async makeClientCrop(crop: any) {
    if (imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }
  toBase64 = (file: File) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  getCroppedImg = (image: any, crop: any, fileName: string) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx?.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
    return new Promise((resolve, reject) => {
      canvas.toBlob(async (blob: any) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        let toBaseString = await this.toBase64(blob);
        console.log("toBaseString", toBaseString);
        this.setState({ base64String: toBaseString });
        resolve(toBaseString);
      }, "image/jpeg");
    });
  };
  render() {
    const { crop, src } = this.state;
    return (
      <React.Fragment>
        <Dialog
          hidden={!this.state.isOpen}
          onDismiss={() => this.onClose()}
          modalProps={{
            isBlocking: true,
            // styles: { main: { maxWidth: "auto", maxHeight: "auto" } },
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: "Crop Image",
          }}
          maxWidth={900}
        >
          {this.state.src && (
            <ReactCrop
              src={src}
              crop={crop}
              ruleOfThirds
              onImageLoaded={this.onImageLoaded}
              onComplete={this.onCropComplete}
              onChange={this.onCropChange}
            />
          )}
          <DialogFooter>
            <DefaultButton
              text="Cancel"
              onClick={() => this.onClose()}
              className="borderless-btn"
            />
            <PrimaryButton
              text="Save"
              onClick={() => this.onClose(this.state.base64String)}
            />
          </DialogFooter>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default ImageCropper;
